// extracted by mini-css-extract-plugin
module.exports = {"packageStudyFields":"styles_packageStudyFields__2IUZf","title":"styles_title__2Fe6O"};